import React, { useState } from 'react'

import { useDialog } from '@/hooks/dialogs/useDialog'

import { SpecificDialogProps } from '@/components/dialogs/Dialog'
import { ConfirmEmailDialog } from '@/components/dialogs/auth/ConfirmEmailDialog'

import { NewEmailDialog } from './NewEmailDialog'

interface MultiSignInProps extends SpecificDialogProps {
  onOpen: () => void
  hasCloseIcon?: boolean
  isUpdateNotificationEmail?: boolean
  needsEmailConfirmation?: boolean
}

export const MultiEmailsDialog = ({
  isOpen,
  hasCloseIcon = false,
  isUpdateNotificationEmail = true,
  onOpen,
  onClose,
  needsEmailConfirmation
}: MultiSignInProps) => {
  const [email, setEmail] = useState('')

  const {
    isOpen: isConfirmEmailOpen,
    openModal: openConfirmEmailModal,
    closeModal: closeConfirmEmailModal
  } = useDialog()

  return (
    <>
      <NewEmailDialog
        {...{
          isOpen,
          onClose,
          hasCloseIcon,
          setEmail,
          openConfirmEmailModal,
          isUpdateNotificationEmail
        }}
      />
      <ConfirmEmailDialog
        {...{
          email,
          isOpen: isConfirmEmailOpen,
          onClose: closeConfirmEmailModal,
          openPrevModal: onOpen,
          isUpdateNotificationEmail,
          needsEmailConfirmation
        }}
      />
    </>
  )
}
